/* gs-size-unit-toggle.js — EU|CM size-unit switcher for the variant picker
   (snippets/variant-picker.liquid). Loaded globally from layout/theme.liquid
   on purpose: the quick-add drawer injects picker markup on collection/search
   pages, where per-section scripts never load.

   Visual-only: swaps the size buttons' visible text between data-gs-eu and
   data-gs-cm; the radio input values stay EU, so selection/add-to-cart are
   untouched. Unit choice persists in localStorage['gs-size-unit'] ('eu'|'cm',
   default 'eu') and syncs across pickers, quick-add drawers and browser tabs. */
(() => {
  const STORAGE_KEY = 'gs-size-unit';

  const getUnit = () => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'cm' ? 'cm' : 'eu';
    } catch (e) {
      return 'eu';
    }
  };

  const storeUnit = (unit) => {
    try {
      localStorage.setItem(STORAGE_KEY, unit);
    } catch (e) {
      /* storage unavailable (private mode) — toggle still works for this page */
    }
  };

  const applyUnit = (unit, root) => {
    (root || document).querySelectorAll('[data-gs-eu][data-gs-cm]').forEach((el) => {
      el.textContent = unit === 'cm' ? el.dataset.gsCm : el.dataset.gsEu;
    });
  };

  class GsSizeUnitToggle extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick);
      this.sync();
      // Late-injected markup (quick-add drawer) initializes itself here.
      applyUnit(getUnit(), this.closest('variant-picker') || undefined);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick = (evt) => {
      const btn = evt.target.closest('button[data-unit]');
      if (!btn || btn.getAttribute('aria-pressed') === 'true') return;
      storeUnit(btn.dataset.unit);
      GsSizeUnitToggle.syncAll();
    };

    sync() {
      const unit = getUnit();
      this.querySelectorAll('button[data-unit]').forEach((btn) => {
        btn.setAttribute('aria-pressed', String(btn.dataset.unit === unit));
      });
    }

    static syncAll() {
      applyUnit(getUnit());
      document.querySelectorAll('gs-size-unit-toggle').forEach((el) => {
        if (typeof el.sync === 'function') el.sync();
      });
    }
  }

  if (!customElements.get('gs-size-unit-toggle')) {
    customElements.define('gs-size-unit-toggle', GsSizeUnitToggle);
  }

  // Cross-tab sync.
  window.addEventListener('storage', (evt) => {
    if (evt.key === STORAGE_KEY) GsSizeUnitToggle.syncAll();
  });
})();
